import LoadingComp from './LoadingComp';

export default function LoadingPageComp() {
  return (
    <div className="h-[75vh] flex flex-col justify-center items-center">
      <LoadingComp />
    </div>
  );
}
